import { ReactNode } from "react";
import styled, { css } from "styled-components";

interface SaveBarProps {
  children: ReactNode;
  unsavedChangesText: string;
  hasUnsavedChanges?: boolean;
}

const SaveBarContainer = styled.div<{ hasUnsavedChanges?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => `${theme.space[2]} ${theme.space[3]}`};
  margin: ${({ theme }) => `${theme.space[4]} 0`};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    margin-inline-end: 20%;
    margin-inline-start: 20%;
  }

  ${(props) =>
    props.hasUnsavedChanges &&
    css`
      margin-inline-end: ${({ theme }) => theme.space[2]};
      margin-inline-start: ${({ theme }) => theme.space[2]};
      border-radius: ${({ theme }) => theme.radii[1]};
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primaryYellow};

      @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
        margin-inline-end: 10%;
        margin-inline-start: 10%;
      }
    `}
`;

const UnsavedChangesText = styled.p`
  padding: 0;
  margin: 0;
  padding-inline-end: ${({ theme }) => theme.space[2]};
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: ${({ theme }) => theme.fontSizes[2]};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
`;

const ButtonContainer = styled.div`
  width: 60%;
`;

const SaveBar = ({
  children,
  unsavedChangesText,
  hasUnsavedChanges,
}: SaveBarProps) => {
  return (
    <SaveBarContainer hasUnsavedChanges={hasUnsavedChanges}>
      {hasUnsavedChanges ? (
        <>
          <UnsavedChangesText>{unsavedChangesText}</UnsavedChangesText>
          <ButtonContainer>{children}</ButtonContainer>
        </>
      ) : (
        children
      )}
    </SaveBarContainer>
  );
};

export default SaveBar;
